'use client';

import WhatsAppIcon from '@/components/icons/whatsapp-icon';
import { Button } from '@/components/ui/button';
import useMediaQuery from '@/hooks/useMediaQuery';
import { SendEventMetapixel } from '@/lib/analytic-send-event';
import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';
import { usePathname } from 'next/navigation';
import React from 'react';

interface WhatsAppWidgetProps {
  phoneNumber?: string;
  message?: string;
}

export default function WhatsAppWidget({ phoneNumber, message }: WhatsAppWidgetProps) {
  const pathname = usePathname();
  const isMobile = useMediaQuery(768);

  const [isFixedAddToCart, setIsFixedAddToCart] = React.useState<boolean>(false);
  const [isFixedCheckoutCart, setIsFixedCheckoutCart] = React.useState<boolean>(false);

  React.useEffect(() => {
    const checkElements = () => {
      setIsFixedAddToCart(!!document.getElementById('fixed-add-to-cart'));
      setIsFixedCheckoutCart(!!document.getElementById('fixed-checkout-cart'));
    };

    checkElements(); // initial check

    const observer = new MutationObserver(() => {
      checkElements();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const handleClick = () => {
    SendEventMetapixel('Contact', {});
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message as string)}`;
    window.open(url, '_blank');
  };

  return (
    <Button
      className={cn(
        'fixed right-4 z-50  rounded-full bg-[#58C151] shadow-md hover:bg-[#25D366]',
        pathname.startsWith('/products/') && isFixedAddToCart
          ? 'bottom-60 lg:bottom-28'
          : 'bottom-16 lg:bottom-6',
        pathname.startsWith('/cart') && isFixedCheckoutCart
          ? 'bottom-40 md:bottom-28 lg:bottom-28 xl:bottom-6'
          : 'bottom-16 lg:bottom-6',
        !isMobile ? 'inline-flex items-center gap-1 px-4 py-6 text-base font-bold' : 'h-14 p-2'
      )}
      onClick={handleClick}
    >
      {isMobile ? (
        <WhatsAppIcon width={40} height={40} />
      ) : (
        <>
          <WhatsAppIcon />
          WhatsApp Us
          <ArrowRight className='h-5 w-5' />
        </>
      )}
    </Button>
  );
}
